import { defineMessages } from 'react-intl';

export default defineMessages({
  identificationPageTitle: {
    id: 'identification_page.title',
  },
  identificationPagePreOpeningButton: {
    id: 'identification_page.pre_open_button',
  },
  searchContainerTitle: {
    id: 'search_container.title',
  },
  searchContainerSupTitile: {
    id: 'search_container.sup_titile',
  },
  searchContainerPoliceNumber: {
    id: 'search_container.police_number',
  },
  searchContainerRegistrationNumber: {
    id: 'search_container.registration_number',
  },
  searchContainerOccurrenceDate: {
    id: 'search_container.occurrence_date',
  },
  searchContainerSearch: {
    id: 'search_container.search',
  },
  searchResultTitle: {
    id: 'identification_page.search_result.title',
  },
  homePage: {
    id: 'identification_page.home_page_button_title',
  },
  noClaimAssociatedWasFound: {
    id: 'identification_page.search.no_claim_was_found',
  },
  claimRejectedFound: {
    id: 'identification_page.search.claim_rejected_found',
  },
  noPolicyAssociatedWasFound: {
    id: 'identification_page.search.no_policy_was_found',
  },
  otherRejectedClaimExist: {
    id: 'identification_page.search.other_rejected_claim_was_found',
  },
  claimsAssociatedWasFound: {
    id: 'identification_page.search.result_was_found',
  },
  searchManagerContainerTitle: {
    id: 'home_page.title',
  },
  searchManagerContainerSupTitile: {
    id: 'home_page.subtitle',
  },
  claimType: {
    id: 'claim_with_not_indexed_PV.claim_type',
  },
  policyNumber: {
    id: 'claim_with_not_indexed_PV.policy_number',
  },
  registrationNumber: {
    id: 'claim_with_not_indexed_PV.registration_number',
  },
  vehicleMark: {
    id: 'claim_with_not_indexed_PV.vehicle_mark',
  },
  lossHour: {
    id: 'claim_with_not_indexed_PV.loss_hour',
  },
  isLawyerAssigned: {
    id: 'claim_with_not_indexed_PV.is_lawyer_assigned',
  },
  lawyerAssigned: {
    id: 'claim_with_not_indexed_PV.lawyer_assigned',
  },
  lawyerNotAssigned: {
    id: 'claim_with_not_indexed_PV.lawyer_not_assigned',
  },
  uploade: {
    id: 'claim_with_not_indexed_PV.uploade',
  },
  indexDocumentDrawerTitle: {
    id: 'index_document_drawer.title',
  },
  indexDocumentDrawerDownload: {
    id: 'claim_with_not_indexed_PV_drawer.download',
  },
  validationSuccessMessage: {
    id: 'indexation_drawer.validation_success_message',
  },
  claimNumber: {
    id: 'claim_with_not_indexed_PV.claim_number',
  },
  saveIndexedDocumentButtonTitle: {
    id: 'claim_with_not_indexed_PV_drawer.save',
  },
  completeSinistre: {
    id: 'identification_page.open_sinistre_button',
  },
  support_document_cp: {
    id: 'identification_page.support_document_cp',
  },
  support_document_attestationDefinitive: {
    id: 'identification_page.support_document_attestationDefinitive',
  },
  openedClaimWarningTitle: {
    id: 'claim_rejected.edit_warning_message',
  },
  openedClaimWarningValidatedTitle: {
    id: 'claim_rejected.edit_warning_message_validated',
  },
  openedClaimWarningPendingTitle: {
    id: 'claim_rejected.edit_warning_message_pending',
  },
  pendingApprovalWarningTilte: {
    id: 'claim_pending_approval.edit_warning_message',
  },
  dialogTitle: {
    id: 'prepopening_page.dialog.title',
  },
  subTitleDialog: {
    id: 'prepopening_page.dialog.sub_title',
  },
  normalTypeTitle: {
    id: 'prepopening_page.dialog.normal_title',
  },
  usageTypeTitle: {
    id: 'prepopening_page.dialog.usage_title',
  },
  confirmButtonTitle: {
    id: 'prepopening_page.dialog.confirm_title',
  },
  cancelButtonTitle: {
    id: 'prepopening_page.dialog.cancel_title',
  },
});
